export const getFileNameFromUrl = (url?: string): string => {
  if (!url) {
    return '';
  }

  try {
    return decodeURIComponent(url.split('/').pop() ?? '');
  } catch {
    return '';
  }
};
